import type IconNames from '@hapvida/hapvida-core-components/src/assets/icons/IconNames';
import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

export enum BeneficiaryStatusEnum {
  ACTIVE = 'Active',
  REGISTERED = 'Registered',
  PENDING = 'Pending',
  SUSPENDED = 'Suspended',
  CANCELED = 'Canceled',
  NONE = 'None',
}

export const BENEFICIARY_STATUS_NAME: Record<BeneficiaryStatusEnum, string> = {
  [BeneficiaryStatusEnum.REGISTERED]: 'Registrado',
  [BeneficiaryStatusEnum.SUSPENDED]: 'Suspenso',
  [BeneficiaryStatusEnum.CANCELED]: 'Cancelado',
  [BeneficiaryStatusEnum.PENDING]: 'Pendente',
  [BeneficiaryStatusEnum.ACTIVE]: 'Ativo',
  [BeneficiaryStatusEnum.NONE]: 'Nenhum',
};

export const BENEFICIARY_STATUS_ICON_NAME: Record<
  BeneficiaryStatusEnum,
  IconNames
> = {
  [BeneficiaryStatusEnum.REGISTERED]: 'actions-b2b-check-circle',
  [BeneficiaryStatusEnum.ACTIVE]: 'actions-b2b-check-circle',
  [BeneficiaryStatusEnum.SUSPENDED]: 'actions-b2b-progress-clock',
  [BeneficiaryStatusEnum.CANCELED]: 'actions-b2b-progress-alert',
  [BeneficiaryStatusEnum.PENDING]: 'actions-b2b-progress-clock',
  [BeneficiaryStatusEnum.NONE]: 'actions-b2b-progress-alert',
};

export const BENEFICIARY_STATUS_COLOR: Record<BeneficiaryStatusEnum, string> = {
  [BeneficiaryStatusEnum.REGISTERED]: NEW_COLORS.SEMANTICS.SUCCESS[700],
  [BeneficiaryStatusEnum.SUSPENDED]: NEW_COLORS.SEMANTICS.ERROR[600],
  [BeneficiaryStatusEnum.CANCELED]: NEW_COLORS.GRAYSCALE[700],
  [BeneficiaryStatusEnum.ACTIVE]: NEW_COLORS.SEMANTICS.SUCCESS[700],
  [BeneficiaryStatusEnum.PENDING]: NEW_COLORS.PRIMARY[500],
  [BeneficiaryStatusEnum.NONE]: NEW_COLORS.GRAYSCALE[300],
};
